<template>
    <div class="user-dropdown" :class="{ 'is-open': isOpen }">
        <img
            :src="$apiUrl() + '/storage/assets/images/' + user.avatar"
            alt="Photo de profil"
            class="w-10 h-10 rounded-full object-cover object-center border-2 border-white shadow-sm"
            @error="
                e =>
                    (e.target.src =
                        '/storage/assets/images/users/profil-pictures/default.png')
            "
            @mouseout="toggleDropdown('exit')"
            @mouseover="toggleDropdown('enter')"
        />
        <i
            class="fas fa-chevron-down text-white"
            @mouseout="toggleDropdown('exit')"
            @mouseover="toggleDropdown('enter')"
            @click="toggleDropdown()"
        ></i>
        <ul
            class="dropdown-menu"
            @mouseout="toggleDropdown('exit')"
            @mouseover="toggleDropdown('enter')"
            @click="toggleDropdown()"
        >
            <li
                @click="
                    $router.push({
                        name: 'user-settings',
                    })
                "
            >
                <span>{{
                    $translate('components.dashboard.menu.user.settings')
                }}</span>
            </li>
            <li
                @click="
                    user.isTemporaryUser
                        ? authStore.logout(true)
                        : authStore.logout()
                "
            >
                {{ $translate('components.dashboard.menu.user.logout') }}
            </li>
        </ul>
        <span
            class="user-name"
            @mouseout="toggleDropdown('exit')"
            @mouseover="toggleDropdown('enter')"
            >{{ user.firstname }}</span
        >
    </div>
</template>

<script setup>
import { useAuthStore } from '@/js/stores/authStore';

import { useRouter } from 'vue-router';

const authStore = useAuthStore();

const $router = useRouter();

defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    user: {
        type: Object,
        default: null,
    },
});

const toggleDropdown = (exit = null) => {
    if (exit === 'exit') {
        return document
            .querySelector('.dropdown-menu')
            .classList.remove('show');
    } else if (exit === 'enter') {
        return document.querySelector('.dropdown-menu').classList.add('show');
    }
    return document.querySelector('.dropdown-menu').classList.toggle('show');
};
</script>

<style lang="scss" scoped>
@use '@/scss/variables' as vars;

.user-dropdown {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    transition: margin-right 0.3s ease-in-out;

    .user-name {
        padding: 0.75rem 0;
        margin-right: 1rem;
        font-size: vars.$defaultFontSize;
        font-weight: bold;
        color: vars.$whiteColor;
    }

    i {
        font-size: 0.8rem;
        cursor: pointer;
        padding: 1rem;
    }

    .dropdown-menu {
        position: fixed;
        top: 50px;
        right: 0.5rem;
        background-color: vars.$whiteColor;
        border-radius: vars.$borderRadius;
        padding: 0.5rem 0;
        box-shadow: vars.$allShadows;
        display: none;
        z-index: 1000;

        li {
            list-style: none;
            padding: 0.5rem 1rem;
            cursor: pointer;
            transition: background-color 0.3s ease-in-out;

            &:hover {
                background-color: vars.$greenColor;
                color: vars.$whiteColor;
            }

            a {
                color: vars.$blackColor;
            }
        }
    }

    .dropdown-menu.show {
        display: block;
    }
}

.user-dropdown.is-open {
    margin-right: 300px;
}

@media screen and (max-width: vars.$mediumBreakpoint) {
    .user-name {
        display: none;
    }
}
</style>
